import { ExporterPropertyBase, } from "./SDKExporterPropertyBase";
export class ExporterPropertyDefinitionEnum extends ExporterPropertyBase {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        super(model);
        // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
        // MARK: - Public properties
        this.type = "Enum";
        this.options = Object.entries(model.options).map(([key, value]) => ({
            key,
            label: value.label,
            description: value.description,
        }));
        this.defaultValue = model.default;
    }
}
